import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Collection, CollectionData} from "../collection.model";
import {CollectionTileComponent} from "./collection-tile/collection-tile.component";
import {CollectionService} from "../collection.service";
import {CollectionOrderDir, CollectionType} from "../collection-utils";
import {NgClass} from "@angular/common";
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {CollectionEditComponent} from "./collection-edit/collection-edit.component";
import {FilterStateService} from "../../dam-header/filter-state.service";
import {FullHeighDirective} from '../../common/full-heigh.directive';
import {MatButton, MatIconButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {MatFormField, MatFormFieldModule} from '@angular/material/form-field';
import {MatOption} from '@angular/material/core';
import {MatSelect} from '@angular/material/select';
import {OrderBy} from '../../assets/order-by';
import {OrderDirection} from '../../assets/order-direction';
import {MatInput} from '@angular/material/input';
import {AssetStateService} from "../../assets/asset.state.service";
import {TranslatePipe} from "@ngx-translate/core";
import {NavStatusService} from '../../nav-status.service';
import {NavigationPoint} from '../../navigation-point';
import {SnackBarService} from "../../common/snack-bar-service";
import {User} from "../../user/user";
import {Subscription} from "rxjs";
import {UserStateService} from "../../user/user.state.service";
import {Router} from "@angular/router";

@Component({
    selector: 'app-collection-overview',
    imports: [
        CollectionTileComponent,
        NgClass,
        FormsModule,
        MatFormFieldModule,
        FullHeighDirective,
        MatButton,
        MatIcon,
        MatFormField,
        MatOption,
        MatSelect,
        MatIconButton,
        MatInput,
        TranslatePipe,
        ReactiveFormsModule,
    ],
    templateUrl: './collection-overview.component.html',
    styleUrl: './collection-overview.component.scss',
})
export class CollectionOverviewComponent implements OnInit, OnDestroy {

    loading = false;
    page = 1;
    collections: Collection[] = [];
    @ViewChild('scroller') scroller: ElementRef | undefined;
    public readonly OrderBy = OrderBy;
    public readonly OrderDirection = OrderDirection;

    selectedType: CollectionType = 'my';
    selectedOrderBy: OrderBy | undefined // = OrderBy.created;
    selectedOrderDir: CollectionOrderDir = 'desc';
    searchForm: FormGroup;
    user: User | null | undefined;
    userSubscription: Subscription;

    constructor(
        private collectionService: CollectionService,
        private dialog: MatDialog,
        private filterStateService: FilterStateService,
        private assetStateService: AssetStateService,
        private navStatusService: NavStatusService,
        private snackBarService: SnackBarService,
        private userStateService: UserStateService,
        private router: Router,
        private fb: FormBuilder
    ) {
        this.searchForm = this.fb.group({
            searchTerm: ['', []],
        })
        this.userSubscription = this.userStateService.user$.subscribe(user => {
            this.user = user
        })
    }

    ngOnInit(): void {
        this.navStatusService.setActiveNavPoint(NavigationPoint.collections);
        this.assetStateService.resetState();
        this.filterStateService.setShowFilterBar(false);
        setTimeout(()=> {
            this.selectedOrderBy = OrderBy.created;
           // console.log('init collection', this.selectedOrderBy);
            this.loadCollections();

        }, 500);
       // this.selectedOrderBy = OrderBy.created;


    }

    loadCollections() {
        if (this.page === 1) {
            this.scrollTop();
        }
        this.loading = true;
        this.collectionService.getCollections(
            this.selectedType,
            undefined,
            this.searchForm.controls['searchTerm'].value,
            this.selectedOrderBy,
            this.selectedOrderDir,
            this.page,
            50 // TODO
        ).subscribe({
            next: collectionView => {
                if (collectionView) {
                    if (this.page === 1) {
                        this.collections = collectionView.data || [];
                    } else {
                        this.collections = [...this.collections, ...collectionView.data || []];
                    }
                } else {
                    this.collections = [];
                    console.warn('Empty response');
                }
            },
            error: error => {
                console.error('Error loading collections', error);
            },
            complete: () => {
                this.loading = false;
            }
        });
    }

    scrollTop() {
        if (this.scroller) {
            this.scroller.nativeElement.scrollTo(0, 0);
        }
    }

    loadNextPage(): void {
        this.page++;
        this.loadCollections();
    }

    onCollectionLoaded(index: number): void {
        if (index === this.collections.length - 10) {
           // console.log(index, this.collections.length);
            this.loadNextPage();
        }
    }

    refreshCollectionView() {
        this.page = 1;
        this.loadCollections();
    }

    toggleSortOrder() {
        if (this.selectedOrderDir === 'asc') {
            this.selectedOrderDir = 'desc';
        } else {
            this.selectedOrderDir = 'asc';
        }
        this.page = 1;
        this.loadCollections();
    }

    selectType(collectionType: CollectionType) {
        this.selectedType = collectionType;
        this.page = 1;
        this.loadCollections();
    }

    createCollection() {
        const dialogRef: MatDialogRef<CollectionEditComponent, CollectionData> = this.dialog.open(
            CollectionEditComponent, {data: {name: '', description: ''}}
        );

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.collectionService.createCollection(result).subscribe({
                    next: () => {
                        this.snackBarService.showMessage({
                            message: 'collections.created.success',
                            success: true
                        })
                        this.refreshCollectionView()
                    },
                    error: error => {
                        this.snackBarService.showMessage({
                            message: 'collections.new.error',
                            success: false
                        });
                        console.error('Error creating collection', error)
                    }
                });
            }
        });
    }

    onCollectionRemoved($event: Collection) {
        this.collections = this.collections.filter(c => c.uuid !== $event.uuid);
    }
    onOpenCollection(col: Collection) {
        // console.log('open collection', col);
        // console.log('selected Type', this.selectedType);
        switch (this.selectedType) {
            case 'my':
                this.router.navigate(['/collections', col.uuid]).then();
                break;
            case 'published':
                if (col.publication) {
                    if (col.permissions.canEdit) {
                        this.router.navigate(['/collections', col.uuid]).then();
                    } else {
                        this.router.navigate(['/collections/public/', col.publication.slug]).then();
                    }

                }
                break;
                case 'shared':
                    this.router.navigate(['/collections', col.uuid]).then();
                break;

        }
    }
    reloadApp() {
        window.location.reload();
    }
    ngOnDestroy(): void {
        if (this.userSubscription) {
            this.userSubscription.unsubscribe();
        }
    }


}
